module.exports = __webpack_public_path__ + "static/media/infromationposter_rotated.f7b72762.png";